export * from "./appSettings";
export * from "./serviceWorkerConfig";
import appSettingsShared from "../../../appSettingsShared.json";
export { appSettingsShared };
